import { TENANT_COM } from 'shared/consts'

import Storage from 'views/assets/scripts/services/storage/storage'
import store from 'shared/store'
import { isDesktop, isMobile } from 'shared/utils/deviceClassUtils'
import { isERxAnnouncement } from 'shared/experiments/utils'
import { PublicRuntimeConfig } from 'server/shop-config/types'
import MountPointsClass from 'shared/utils/mountPoints'

const SELECTOR_TOOLTIP_TARGET = '[data-clientside-hook~="show-erx-tooltip"]'
const SELECTOR_TOOLTIP_CLOSE = '[data-clientside-hook~="close-erx-tooltip"]'
const SELECTOR_MENU_ITEM = '[data-clientside-hook~="handle-erx-announcement"]'
const SELECTOR_MENU_ITEM_BUTTON =
  '[data-clientside-hook~="wrap-erx-announcement"]'
const CLASS_TOOLTIP_ACTIVE = 'o-ErxTooltip--active'

const STORAGE_TOOLTIP_KEY = 'isErxTooltipClosed'

const tooltipTarget = document.querySelector(SELECTOR_TOOLTIP_TARGET)
const menuItem = document.querySelector(SELECTOR_MENU_ITEM)
const localStorage = new Storage('localStorage')

const markTooltipClosed = () => localStorage.set(STORAGE_TOOLTIP_KEY, true)
const isTooltipClosed = () => localStorage.get(STORAGE_TOOLTIP_KEY)
const showTooltip = () => tooltipTarget!.classList.add(CLASS_TOOLTIP_ACTIVE)
const hideToolip = () => tooltipTarget!.classList.remove(CLASS_TOOLTIP_ACTIVE)
const hideMenuItem = () =>
  menuItem!.querySelector(SELECTOR_MENU_ITEM_BUTTON)?.classList.add('u-hidden')

const shouldDisplayTooltip = (
  publicRuntimeConfig: PublicRuntimeConfig
): boolean => {
  const {
    publicConfig: { tenant, deviceClass },
    pageProperties: { firstImpressionFlag, experiments }
  } = publicRuntimeConfig

  return Boolean(
    firstImpressionFlag &&
      tenant === TENANT_COM &&
      isDesktop(deviceClass) &&
      !isTooltipClosed() &&
      isERxAnnouncement(experiments)
  )
}

const shouldDisplayMenuItem = (
  publicRuntimeConfig: PublicRuntimeConfig
): boolean => {
  const {
    publicConfig: { tenant, deviceClass },
    pageProperties: { experiments }
  } = publicRuntimeConfig

  return Boolean(
    tenant === TENANT_COM &&
      isMobile(deviceClass) &&
      isERxAnnouncement(experiments)
  )
}

const bindMenuItem = (publicRuntimeConfig: PublicRuntimeConfig) => {
  const {
    publicConfig: { mountPoints, tenant, language },
    pageProperties: { coreShopEnvironment }
  } = publicRuntimeConfig

  const mountPointsInstance = new MountPointsClass({
    mountPoints,
    tenant,
    language,
    coreShopEnvironment
  })

  menuItem!.querySelector('a')!.href =
    mountPointsInstance.getRedeemRecipe('#e-rezept')
}

const bindTooltipCloseButton = () =>
  document
    .querySelector(SELECTOR_TOOLTIP_CLOSE)
    ?.addEventListener('click', event => {
      event.preventDefault()
      hideToolip()
      markTooltipClosed()
    })

export default () => {
  const publicRuntimeConfig = store.getPublicRuntimeConfig()

  if (tooltipTarget && shouldDisplayTooltip(publicRuntimeConfig)) {
    bindTooltipCloseButton()
    showTooltip()
  }

  if (menuItem) {
    shouldDisplayMenuItem(publicRuntimeConfig)
      ? bindMenuItem(publicRuntimeConfig)
      : hideMenuItem()
  }
}
